export default "/assets/webpack-assets/GT-Walsheim-Pro-Regular.02a342d8130585953c407995c0f558a6.woff";